/**
 * Ticket Service - API client for ticketing system endpoints
 * Handles all ticket-related API calls with authentication
 */
import api from '../utils/api';

const ticketService = {
  /**
   * Create a new support ticket
   */
  createTicket: async (ticketData) => {
    try {
      const data = await api.post('/api/tickets', ticketData);
      return data;
    } catch (error) {
      console.error("Error creating ticket:", error);
      throw error;
    }
  },

  /**
   * Get all tickets (paginated)
   * For school admin: shows only their school's tickets
   * For super admin: shows all tickets
   */
  getTickets: async (page = 1, limit = 20, status = null, category = null) => {
    try {
      const params = { page, limit };
      if (status) params.status = status;
      if (category) params.category = category;
      
      const data = await api.get('/api/tickets', { params });
      return data;
    } catch (error) {
      console.error("Error fetching tickets:", error);
      throw error;
    }
  },

  /**
   * Get single ticket with details and comments
   */
  getTicketDetail: async (ticketId) => {
    try {
      const data = await api.get(`/api/tickets/${ticketId}`);
      return data;
    } catch (error) {
      console.error("Error fetching ticket detail:", error);
      throw error;
    }
  },

  /**
   * Update ticket status (Super Admin only)
   */
  updateTicketStatus: async (ticketId, status, assignedToId = null) => {
    try {
      const data = await api.put(`/api/tickets/${ticketId}/status`, {
        status,
        assigned_to_id: assignedToId
      });
      return data;
    } catch (error) {
      console.error("Error updating ticket status:", error);
      throw error;
    }
  },

  /**
   * Add comment to ticket
   */
  addComment: async (ticketId, comment, isInternal = false) => {
    try {
      const data = await api.post(`/api/tickets/${ticketId}/comments`, {
        comment,
        is_internal: isInternal
      });
      return data;
    } catch (error) {
      console.error("Error adding comment:", error);
      throw error;
    }
  },

  /**
   * Close ticket with resolution (Super Admin only)
   */
  closeTicket: async (ticketId, resolutionSummary) => {
    try {
      const data = await api.post(`/api/tickets/${ticketId}/close`, {
        resolution_summary: resolutionSummary
      });
      return data;
    } catch (error) {
      console.error("Error closing ticket:", error);
      throw error;
    }
  },

  /**
   * Get ticket statistics
   */
  getTicketStats: async () => {
    try {
      const data = await api.get('/api/tickets/stats/overview');
      return data;
    } catch (error) {
      console.error("Error fetching ticket stats:", error);
      throw error;
    }
  }
};

export default ticketService;
